<section class="bk-panel rt" aria-labelledby="rt-title">
  <header class="rt__head">
    <div class="rt__intro">
      <h2 class="bk-eyebrow" id="rt-title">{{ tableTitle || "Recipients" }}</h2>
      @if (paginated) {
        <!-- Stays in place and only its text changes, so searches, filters and pages are announced -->
        <p class="rt__sub" aria-live="polite" aria-atomic="true">{{ countLabel }}</p>
      }
    </div>

    @if (exportable) {
      <ng-container
        *hasPermission="{ category: 'CAMPAIGN_MANAGEMENT', permission: 'export-campaign-reports' }"
      >
        <button
          type="button"
          class="bk-btn bk-btn--ghost"
          [disabled]="exporting"
          [attr.aria-busy]="exporting || null"
          (click)="export.emit()"
        >
          <span class="bk-sym" aria-hidden="true">download</span>
          {{ exporting ? "Preparing file…" : "Download recipients" }}
        </button>
      </ng-container>
    }
  </header>

  @if (exportNote) {
    <p class="rt__note" aria-hidden="true">{{ exportNote }}</p>
  }
  <!-- Persistent live regions for the note: failures as alerts, the rest politely -->
  <span class="bk-sr-only" aria-live="polite">{{ exportFailed ? "" : exportNote }}</span>
  <span class="bk-sr-only" role="alert">{{ exportFailed ? exportNote : "" }}</span>

  <!-- Send, search, delivery outcome and order -->
  <div class="rt__toolbar">
    @if (tableOptions.length) {
      <label class="rt__send">
        <span class="bk-sr-only">Send</span>
        <select class="bk-field__input rt__select" (change)="optionChange($event)">
          @for (option of tableOptions; track option.id) {
            <option [value]="option.id" [selected]="isSelected(option)">{{ option.name }}</option>
          }
        </select>
      </label>
    }

    <app-search-input label="Search recipients"
      class="rt__search"
      placeholder="Search by name or number"
      (valueChange)="searchTableData($event)"
    ></app-search-input>

    <app-status-filter
      label="Delivery"
      [options]="statusOptions"
      [selectedValue]="statusFilter"
      (selectionChange)="filterStatus($event)"
    />

    <app-sort-dropdown
      [groups]="sortGroups"
      [selectedValue]="selectedSort"
      (selectionChange)="sortTableData($any($event))"
    />
  </div>

  <data-table label="Delivery receipts" [seamless]="true" [loading]="loading" [maxHeight]="'640px'" [skeletonColumns]="6">
    @if (rows.length) {
      <table class="bk-log">
        <thead>
          <tr>
            <th scope="col">Recipient</th>
            <th scope="col" class="col-number">Mobile number</th>
            <th scope="col" class="col-group">Group</th>
            <th scope="col" class="col-gender">Gender</th>
            <th scope="col" class="num col-age">Age</th>
            <th scope="col" class="col-country">Country</th>
            <th scope="col" class="col-status">Delivery</th>
            <th scope="col" class="num col-when">Time</th>
          </tr>
        </thead>
        <tbody>
          @for (row of rows; track row.key) {
            <tr>
              <td class="col-name">
                <span class="bk-msg">
                  <span class="bk-msg__subject">{{ row.name }}</span>
                  <span class="bk-msg__preview rt__number-inline">{{ row.number }}</span>
                </span>
              </td>
              <td class="col-number rt__number">{{ row.number }}</td>
              <td class="quiet col-group">{{ row.group }}</td>
              <td class="quiet col-gender">{{ row.gender }}</td>
              <td class="num quiet col-age">{{ row.age }}</td>
              <td class="quiet col-country">{{ row.country }}</td>
              <td class="col-status">
                <app-status [text]="row.status" [status]="row.tone" />
              </td>
              <td class="num quiet col-when">{{ row.when }}</td>
            </tr>
          }
        </tbody>
      </table>
    } @else {
      <app-empty-state
        [icon]="filtered ? 'search' : 'group'"
        [message]="filtered ? 'No recipients match' : 'No recipients for this send yet'"
        [hint]="
          filtered
            ? 'Try another name or number, or show all recipients.'
            : 'Recipients appear once the send goes out and receipts start coming back.'
        "
        size="medium"
      />
    }
  </data-table>

  @if (paginated && (totalPages ?? 1) > 1) {
    <div class="rt__pagination">
      <app-pagination
        [currentPage]="currentPage"
        [totalPages]="totalPages ?? 1"
        [totalItems]="totalItems ?? undefined"
        [pageSize]="pageSize"
        [loading]="loading"
        (changePage)="changePage.emit($event)"
        (onNext)="changePage.emit(currentPage + 1)"
        (onPrev)="changePage.emit(currentPage - 1)"
        (pageSizeChange)="pageSizeChange.emit($event)"
      />
    </div>
  }

  <!-- view all -->
  @if (miniTable && !paginated && tableData.length > 5) {
    <div class="rt__more">
      <a routerLink="contact-details" class="bk-more">
        View all recipients <span class="bk-sym" aria-hidden="true">arrow_outward</span>
      </a>
    </div>
  }
</section>
